"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "serialize", {
    enumerable: true,
    get: function() {
        return serialize;
    }
});
const _pdfparse = /*#__PURE__*/ _interop_require_default(require("pdf-parse"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const serializers = {
    'application/pdf': async (stream)=>{
        const data = await getDataFromStream(stream);
        const pdfData = await (0, _pdfparse.default)(data);
        return {
            text: pdfData.text,
            images: []
        };
    },
    default: async (stream)=>{
        const data = await getDataFromStream(stream);
        const text = data.toString('utf-8');
        return {
            text,
            images: []
        };
    }
};
const getDataFromStream = (stream)=>{
    return new Promise((resolve, reject)=>{
        const chunks = [];
        stream.on('data', (chunk)=>{
            chunks.push(chunk);
        });
        stream.on('end', ()=>{
            resolve(Buffer.concat(chunks));
        });
        stream.on('error', (error)=>{
            reject(error);
        });
    });
};
const serialize = async (mimetype, stream, fallback)=>{
    try {
        const serializer = serializers[mimetype] || serializers.default;
        const data = await serializer(stream);
        return data;
    } catch (error) {
        console.error(error);
        return {
            text: fallback != null ? fallback : '@file_not_supported',
            images: []
        };
    }
};
